import { customDispatch } from "@affinity/Store/ServiceBase";
import ServiceEmail from "@affinity/Store/ServiceEmail";
import { createHandlerChainRunner, Handler, HasOnComplete, HasOnError } from "@insite/client-framework/HandlerCreator";

// External parameters
export interface EmailQuoteParameters {
    productId: string,
    productDescription: string,
    email: string,
    postcode: string,
    quantity: number,
    quoteOption: string,
    netCost: number,
    netUnitPrice: number
}

// Internal parameters
interface Props {
    result: Object,
    errorMessage: string
}

type Parameter = EmailQuoteParameters & HasOnComplete<Props> & HasOnError<Props>;

type HandlerType = Handler<Parameter, Props>;

const FireOnError: HandlerType = props => {
    if(props.errorMessage){
        props.parameter.onError?.(props);
    }
};

const FireOnComplete: HandlerType = props => {
    // todo depending on result build up, handle complete
    if(props.result){
        props.parameter.onComplete?.(props.result);
    }
};

export const EmailQuote: HandlerType = async (props) => {
    const service = new ServiceEmail();

    const message = `${props.parameter.quoteOption}, for postcode: ${props.parameter.postcode}, quantity:${props.parameter.quantity}, total £${  props.parameter.netCost  } inc VAT (£${  props.parameter.netUnitPrice  }/litre ex VAT)`;
    props.errorMessage = "";
    try{
        props.result = await service.postTellAFriendUrl(
            props.parameter.email, 
            props.parameter.productId,
            props.parameter.productDescription,
            message
        );
    }catch(err){
        const errorMessage = err?.errorMessage || err?.errorJson?.exceptionMessage || err?.errorJson?.message;
        props.errorMessage = errorMessage;
    }
    
    // Do something with result?
}

const Tracking: HandlerType = props => {
    //
}

const chain = [
    EmailQuote,
    FireOnError,
    FireOnComplete,
    Tracking,
];

const createAccount = createHandlerChainRunner(chain, "SetEmailQuote");
export default createAccount;